import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'app/components/Pagination/Pagination'
import {
  getFavoriteActivitiesFilteredTotalPages,
  getFavoriteActivitiesFilteredShowPagination,
  getFavoriteActivitiesPaginationCurrent,
} from 'store/entities/favoriteActivities/selectors'
import { selectPage } from 'store/entities/favoriteActivities/actions'
import { scrollBodyTo } from 'store/entities/ui/actions'

const mapStateToProps = state => ({
  showPagination: getFavoriteActivitiesFilteredShowPagination(state),
  pageCount: getFavoriteActivitiesFilteredTotalPages(state),
  currentPage: getFavoriteActivitiesPaginationCurrent(state),
})

const mapDispatchToProps = {
  onSelectPage: selectPage,
  scrollBodyTo,
}

const FavoriteActivitiesPagination = ({ showPagination, pageCount, currentPage, onSelectPage, scrollBodyTo }) =>
  showPagination && (
    <div className="favorite-activities-pagination">
      <Pagination
        pageCount={pageCount}
        initialPage={currentPage}
        pageRangeDisplayed={2}
        onPageChange={({ selected }) => {
          onSelectPage(selected)
          scrollBodyTo(0)
        }}
      />
    </div>
  )

FavoriteActivitiesPagination.displayName = 'FavoriteActivitiesPagination'

const FavoriteActivitiesPaginationContainer = connect(mapStateToProps, mapDispatchToProps)(FavoriteActivitiesPagination)

FavoriteActivitiesPaginationContainer.displayName = 'FavoriteActivitiesPaginationContainer'

export default FavoriteActivitiesPaginationContainer
